(function (root) {
  'use strict';

  var COUNTRIES = ['IT', 'FR', 'ES', 'DE', 'PT', 'IE'];
  var LOCK = root.MERIDIAN_LOCK || null;
  var LOCK_LANG = String(LOCK && LOCK.locale || '').toLowerCase().split('-')[0];
  var LOCK_COUNTRIES = Array.isArray(LOCK && LOCK.countries)
    ? LOCK.countries.map(function (code) { return String(code || '').toUpperCase(); }).filter(Boolean)
    : [];
  var LANG_COUNTRY = { it: 'IT', fr: 'FR', es: 'ES', de: 'DE', pt: 'PT' };
  var NUMBER_LOCALE = { it: 'it-IT', fr: 'fr-FR', es: 'es-ES', de: 'de-DE', pt: 'pt-PT', en: 'en-IE' };
  var SUPPORTED = { it: 1, fr: 1, es: 1, de: 1, pt: 1, en: 1 };

  var PROVINCES = {
    IT: ['Agrigento', 'Alessandria', 'Ancona', 'Valle d\u2019Aosta', 'Arezzo', 'Ascoli Piceno', 'Asti', 'Avellino',
      'Bari', 'Barletta-Andria-Trani', 'Belluno', 'Benevento', 'Bergamo', 'Biella', 'Bologna', 'Bolzano', 'Brescia',
      'Brindisi', 'Cagliari', 'Caltanissetta', 'Campobasso', 'Caserta', 'Catania', 'Catanzaro', 'Chieti', 'Como',
      'Cosenza', 'Cremona', 'Crotone', 'Cuneo', 'Enna', 'Fermo', 'Ferrara', 'Firenze', 'Foggia', 'Forl\u00ec-Cesena',
      'Frosinone', 'Genova', 'Gorizia', 'Grosseto', 'Imperia', 'Isernia', 'L\u2019Aquila', 'La Spezia', 'Latina',
      'Lecce', 'Lecco', 'Livorno', 'Lodi', 'Lucca', 'Macerata', 'Mantova', 'Massa-Carrara', 'Matera', 'Messina',
      'Milano', 'Modena', 'Monza e Brianza', 'Napoli', 'Novara', 'Nuoro', 'Oristano', 'Padova', 'Palermo', 'Parma',
      'Pavia', 'Perugia', 'Pesaro e Urbino', 'Pescara', 'Piacenza', 'Pisa', 'Pistoia', 'Pordenone', 'Potenza',
      'Prato', 'Ragusa', 'Ravenna', 'Reggio Calabria', 'Reggio Emilia', 'Rieti', 'Rimini', 'Roma', 'Rovigo',
      'Salerno', 'Sassari', 'Savona', 'Siena', 'Siracusa', 'Sondrio', 'Sud Sardegna', 'Taranto', 'Teramo', 'Terni',
      'Torino', 'Trapani', 'Trento', 'Treviso', 'Trieste', 'Udine', 'Varese', 'Venezia', 'Verbano-Cusio-Ossola',
      'Vercelli', 'Verona', 'Vibo Valentia', 'Vicenza', 'Viterbo'],
    FR: ['Ain', 'Aisne', 'Allier', 'Alpes-de-Haute-Provence', 'Hautes-Alpes', 'Alpes-Maritimes', 'Ard\u00e8che',
      'Ardennes', 'Ari\u00e8ge', 'Aube', 'Aude', 'Aveyron', 'Bouches-du-Rh\u00f4ne', 'Calvados', 'Cantal', 'Charente',
      'Charente-Maritime', 'Cher', 'Corr\u00e8ze', 'Corse-du-Sud', 'Haute-Corse', 'C\u00f4te-d\u2019Or', 'C\u00f4tes-d\u2019Armor',
      'Creuse', 'Dordogne', 'Doubs', 'Dr\u00f4me', 'Eure', 'Eure-et-Loir', 'Finist\u00e8re', 'Gard', 'Haute-Garonne',
      'Gers', 'Gironde', 'H\u00e9rault', 'Ille-et-Vilaine', 'Indre', 'Indre-et-Loire', 'Is\u00e8re', 'Jura', 'Landes',
      'Loir-et-Cher', 'Loire', 'Haute-Loire', 'Loire-Atlantique', 'Loiret', 'Lot', 'Lot-et-Garonne', 'Loz\u00e8re',
      'Maine-et-Loire', 'Manche', 'Marne', 'Haute-Marne', 'Mayenne', 'Meurthe-et-Moselle', 'Meuse', 'Morbihan',
      'Moselle', 'Ni\u00e8vre', 'Nord', 'Oise', 'Orne', 'Pas-de-Calais', 'Puy-de-D\u00f4me', 'Pyr\u00e9n\u00e9es-Atlantiques',
      'Hautes-Pyr\u00e9n\u00e9es', 'Pyr\u00e9n\u00e9es-Orientales', 'Bas-Rhin', 'Haut-Rhin', 'Rh\u00f4ne', 'Haute-Sa\u00f4ne',
      'Sa\u00f4ne-et-Loire', 'Sarthe', 'Savoie', 'Haute-Savoie', 'Paris', 'Seine-Maritime', 'Seine-et-Marne', 'Yvelines',
      'Deux-S\u00e8vres', 'Somme', 'Tarn', 'Tarn-et-Garonne', 'Var', 'Vaucluse', 'Vend\u00e9e', 'Vienne', 'Haute-Vienne',
      'Vosges', 'Yonne', 'Territoire de Belfort', 'Essonne', 'Hauts-de-Seine', 'Seine-Saint-Denis', 'Val-de-Marne',
      'Val-d\u2019Oise'],
    ES: ['\u00c1lava', 'Albacete', 'Alicante', 'Almer\u00eda', 'Asturias', '\u00c1vila', 'Badajoz', 'Barcelona', 'Burgos',
      'C\u00e1ceres', 'C\u00e1diz', 'Cantabria', 'Castell\u00f3n', 'Ciudad Real', 'C\u00f3rdoba', 'Cuenca', 'Girona',
      'Granada', 'Guadalajara', 'Guip\u00fazcoa', 'Huelva', 'Huesca', 'Illes Balears', 'Ja\u00e9n', 'La Coru\u00f1a',
      'La Rioja', 'Las Palmas', 'Le\u00f3n', 'Lleida', 'Lugo', 'Madrid', 'M\u00e1laga', 'Murcia', 'Navarra', 'Ourense',
      'Palencia', 'Pontevedra', 'Salamanca', 'Santa Cruz de Tenerife', 'Segovia', 'Sevilla', 'Soria', 'Tarragona',
      'Teruel', 'Toledo', 'Valencia', 'Valladolid', 'Vizcaya', 'Zamora', 'Zaragoza', 'Ceuta', 'Melilla'],
    DE: ['Baden-W\u00fcrttemberg', 'Bayern', 'Berlin', 'Brandenburg', 'Bremen', 'Hamburg', 'Hessen',
      'Mecklenburg-Vorpommern', 'Niedersachsen', 'Nordrhein-Westfalen', 'Rheinland-Pfalz', 'Saarland', 'Sachsen',
      'Sachsen-Anhalt', 'Schleswig-Holstein', 'Th\u00fcringen'],
    PT: ['Aveiro', 'Beja', 'Braga', 'Bragan\u00e7a', 'Castelo Branco', 'Coimbra', '\u00c9vora', 'Faro', 'Guarda',
      'Leiria', 'Lisboa', 'Portalegre', 'Porto', 'Santar\u00e9m', 'Set\u00fabal', 'Viana do Castelo', 'Vila Real',
      'Viseu', 'A\u00e7ores', 'Madeira'],
    IE: ['Carlow', 'Cavan', 'Clare', 'Cork', 'Donegal', 'Dublin', 'Galway', 'Kerry', 'Kildare', 'Kilkenny', 'Laois',
      'Leitrim', 'Limerick', 'Longford', 'Louth', 'Mayo', 'Meath', 'Monaghan', 'Offaly', 'Roscommon', 'Sligo',
      'Tipperary', 'Waterford', 'Westmeath', 'Wexford', 'Wicklow'],
    AE: ['Abu Dhabi', 'Ajman', 'Dubai', 'Fujairah', 'Ras al-Khaimah', 'Sharjah', 'Umm al-Quwain'],
  };

  var CITY_FALLBACK = {
    IT: { city: 'Milano', zip: '20100' },
    FR: { city: 'Paris', zip: '75001' },
    ES: { city: 'Madrid', zip: '28001' },
    DE: { city: 'Berlin', zip: '10115' },
    PT: { city: 'Lisboa', zip: '1000-001' },
    IE: { city: 'Dublin', zip: 'D02' },
    AE: { city: 'Dubai', zip: '00000' },
    GB: { city: 'London', zip: 'SW1A 1AA' },
  };

  var I18N = {
    it: {
      cart: 'Carrello', summary: 'Riepilogo ordine', checkout: 'Check-out', contacts: 'Contatti', email: 'Email',
      newsletter: 'Inviami email con notizie e offerte', delivery: 'Consegna', country: 'Paese / Regione',
      first_name: 'Nome', last_name: 'Cognome', address: 'Indirizzo',
      address2: 'Interno, scala, ecc. (facoltativo)', city: 'Citt\u00e0', phone: 'Telefono (facoltativo)',
      zip_IT: 'CAP', zip_FR: 'Codice postale', zip_ES: 'Codice postale', zip_DE: 'CAP', zip_PT: 'Codice postale', zip_IE: 'Eircode',
      zip: 'Codice postale', zip_AE: 'Codice postale', zip_GB: 'Postcode',
      province_IT: 'Provincia', province_FR: 'Dipartimento', province_ES: 'Provincia', province_DE: 'Land',
      province_PT: 'Distretto', province_IE: 'Contea', province: 'Provincia', province_AE: 'Emirato', province_GB: 'Contea',
      shipping_method: 'Metodo di spedizione',
      ship_empty: 'Per visualizzare le modalit\u00e0 di spedizione disponibili, inserisci il tuo indirizzo di spedizione.',
      standard_shipping: 'Spedizione standard', shipping: 'Spedizione', free: 'Gratis',
      ship_express_tracked: 'Spedizione Express Tracciata',
      ship_tracked: 'Spedizione tracciata',
      ship_eta_inner: 'Consegna 24/48 ore',
      ship_eta: '(Consegna 24/48 ore)',
      enter_address: 'Inserisci indirizzo di spedizione', payment: 'Pagamento',
      pay_secure: 'Tutte le transazioni sono sicure e crittografate.', credit_card: 'Carta di credito',
      card_number: 'Numero della carta', card_expiry: 'MM / AA', card_cvc: 'CVC',
      card_name: 'Nome sulla carta',
      pay_loading: 'Caricamento del modulo di pagamento sicuro\u2026',
      psp_choose: 'Scegli come pagare', psp_comercia: 'Comercia', psp_nexi: 'Nexi',
      psp_pick: 'Seleziona Comercia o Nexi per continuare.',
      psp_nexi_hint: 'Clicca Effettua ordine: verrai portato sulla pagina sicura Nexi.',
      bank_connecting: 'Connessione sicura alla banca\u2026', cancel_pay: 'Annulla pagamento',
      disclaimer: 'Continuando con il pagamento, accetti che l\u2019importo venga addebitato sul metodo di pagamento al momento dell\u2019elaborazione dell\u2019ordine.',
      pay_now: 'Effettua ordine', processing: 'Elaborazione in corso\u2026', subtotal: 'Subtotale', total: 'Totale',
      pay_title: 'Pagamento sicuro', wallet_title: 'Apple Pay o Google Pay',
      wallet_connecting: 'Connessione ad Apple Pay / Google Pay\u2026',
      popup_blocked: 'Il browser ha bloccato il popup. Consenti i popup per questo sito e riprova.',
      pay_declined: 'Il pagamento \u00e8 stato rifiutato. Controlla i dati o usa un altro metodo.',
      pay_failed: 'Pagamento non riuscito. Riprova.',
      network: 'Impossibile contattare il servizio di pagamento. Controlla la connessione e riprova.',
      threeds_failed: 'La verifica della banca non \u00e8 andata a buon fine. Controlla i dati e riprova.',
      cart_load: 'Impossibile caricare il carrello. Ricarica la pagina.',
      pay_load: 'Impossibile caricare il modulo di pagamento. Riprova.',
      wallet_fail: 'Impossibile avviare Apple Pay / Google Pay.',
      err_card: 'La carta \u00e8 stata rifiutata. Controlla i dati o usa un\u2019altra carta.',
      err_email: 'Inserisci un indirizzo email valido.', err_address: 'Completa l\u2019indirizzo di spedizione.',
      err_shipping: 'Non effettuiamo spedizioni verso il paese selezionato.', err_empty: 'Il tuo carrello \u00e8 vuoto.',
      err_item: 'Un prodotto nel carrello non \u00e8 pi\u00f9 disponibile.',
      err_locked: 'Questo pagamento non \u00e8 pi\u00f9 disponibile. Ricarica la pagina.',
      err_amount: 'L\u2019importo dell\u2019ordine non \u00e8 valido.',
      customer: 'Cliente', address_pending: 'Da completare',
      confirming: 'Conferma dell\u2019ordine in corso\u2026',
      please_wait: 'Attendi qualche secondo mentre registriamo il tuo ordine.',
      thanks: 'Grazie per il tuo ordine!', order_ok: 'Il tuo ordine \u00e8 stato registrato con successo.',
      email_soon: 'Riceverai a breve un\u2019email di conferma con tutti i dettagli dell\u2019ordine e le informazioni di spedizione.',
      continue: 'Continua lo shopping', failed_title: 'Qualcosa non ha funzionato',
      failed_body: 'Non siamo riusciti a confermare il tuo ordine. Se l\u2019addebito \u00e8 andato a buon fine, l\u2019ordine verr\u00e0 registrato comunque.',
      failed_contact: 'Contattaci indicando l\u2019indirizzo email usato al momento del pagamento e ti aggiorneremo subito.',
      back_store: 'Torna al negozio', order_confirmed: 'Ordine {name} confermato \u00b7 {amount}',
      country_IT: 'Italia', country_FR: 'Francia', country_ES: 'Spagna', country_DE: 'Germania',
      country_PT: 'Portogallo', country_IE: 'Irlanda',
    },
    fr: {
      cart: 'Panier', summary: 'R\u00e9capitulatif de la commande', checkout: 'Paiement', contacts: 'Coordonn\u00e9es',
      email: 'E-mail', newsletter: 'Envoyez-moi les nouveaut\u00e9s et les offres par e-mail', delivery: 'Livraison',
      country: 'Pays / R\u00e9gion', first_name: 'Pr\u00e9nom', last_name: 'Nom', address: 'Adresse',
      address2: 'Appartement, b\u00e2timent, etc. (facultatif)', city: 'Ville', phone: 'T\u00e9l\u00e9phone (facultatif)',
      zip_IT: 'Code postal', zip_FR: 'Code postal', zip_ES: 'Code postal', zip_DE: 'Code postal', zip_PT: 'Code postal', zip_IE: 'Eircode',
      zip: 'Code postal', zip_AE: 'Code postal', zip_GB: 'Postcode',
      province_IT: 'Province', province_FR: 'D\u00e9partement', province_ES: 'Province', province_DE: 'Land',
      province_PT: 'District', province_IE: 'Comt\u00e9', province: 'R\u00e9gion', province_AE: '\u00c9mirat', province_GB: 'Comt\u00e9',
      shipping_method: 'Mode d\u2019exp\u00e9dition',
      ship_empty: 'Saisissez votre adresse de livraison pour afficher les modes d\u2019exp\u00e9dition disponibles.',
      standard_shipping: 'Livraison standard', shipping: 'Livraison', free: 'Gratuit',
      ship_express_tracked: 'Livraison express suivie',
      ship_tracked: 'Livraison suivie',
      ship_eta_inner: 'Livraison 24/48 h',
      ship_eta: '(Livraison 24/48 h)',
      enter_address: 'Saisir l\u2019adresse de livraison', payment: 'Paiement',
      pay_secure: 'Toutes les transactions sont s\u00e9curis\u00e9es et chiffr\u00e9es.', credit_card: 'Carte de cr\u00e9dit',
      card_number: 'Num\u00e9ro de carte', card_expiry: 'MM / AA', card_cvc: 'CVC',
      card_name: 'Nom sur la carte',
      pay_loading: 'Chargement du formulaire de paiement s\u00e9curis\u00e9\u2026',
      psp_choose: 'Choisissez comment payer', psp_comercia: 'Comercia', psp_nexi: 'Nexi',
      psp_pick: 'S\u00e9lectionnez Comercia ou Nexi pour continuer.',
      psp_nexi_hint: 'Cliquez sur Payer : vous serez redirig\u00e9 vers la page s\u00e9curis\u00e9e Nexi.',
      bank_connecting: 'Connexion s\u00e9curis\u00e9e \u00e0 la banque\u2026', cancel_pay: 'Annuler le paiement',
      disclaimer: 'En continuant, vous acceptez que le montant soit d\u00e9bit\u00e9 sur votre moyen de paiement lors du traitement de la commande.',
      pay_now: 'Passer la commande', processing: 'Traitement en cours\u2026', subtotal: 'Sous-total', total: 'Total',
      pay_title: 'Paiement s\u00e9curis\u00e9', wallet_title: 'Apple Pay ou Google Pay',
      wallet_connecting: 'Connexion \u00e0 Apple Pay / Google Pay\u2026',
      popup_blocked: 'Le navigateur a bloqu\u00e9 la fen\u00eatre. Autorisez les pop-ups pour ce site, puis r\u00e9essayez.',
      pay_declined: 'Le paiement a \u00e9t\u00e9 refus\u00e9. V\u00e9rifiez les informations ou utilisez un autre moyen de paiement.',
      pay_failed: 'Paiement impossible. R\u00e9essayez.',
      network: 'Impossible de contacter le service de paiement. V\u00e9rifiez la connexion et r\u00e9essayez.',
      threeds_failed: 'La v\u00e9rification bancaire a \u00e9chou\u00e9. V\u00e9rifiez les informations et r\u00e9essayez.',
      cart_load: 'Impossible de charger le panier. Actualisez la page.',
      pay_load: 'Impossible de charger le formulaire de paiement. R\u00e9essayez.',
      wallet_fail: 'Impossible de lancer Apple Pay / Google Pay.',
      err_card: 'La carte a \u00e9t\u00e9 refus\u00e9e. V\u00e9rifiez les informations ou utilisez une autre carte.',
      err_email: 'Saisissez une adresse e-mail valide.', err_address: 'Compl\u00e9tez l\u2019adresse de livraison.',
      err_shipping: 'Nous ne livrons pas dans le pays s\u00e9lectionn\u00e9.', err_empty: 'Votre panier est vide.',
      err_item: 'Un article du panier n\u2019est plus disponible.',
      err_locked: 'Ce paiement n\u2019est plus disponible. Actualisez la page.',
      err_amount: 'Le montant de la commande n\u2019est pas valide.',
      customer: 'Client', address_pending: '\u00c0 compl\u00e9ter',
      confirming: 'Confirmation de la commande\u2026',
      please_wait: 'Patientez quelques instants pendant l\u2019enregistrement de votre commande.',
      thanks: 'Merci pour votre commande !', order_ok: 'Votre commande a bien \u00e9t\u00e9 enregistr\u00e9e.',
      email_soon: 'Vous recevrez bient\u00f4t un e-mail de confirmation avec les d\u00e9tails de la commande et les informations de livraison.',
      continue: 'Continuer vos achats', failed_title: 'Un probl\u00e8me est survenu',
      failed_body: 'Nous n\u2019avons pas pu confirmer votre commande. Si le paiement a abouti, la commande sera tout de m\u00eame enregistr\u00e9e.',
      failed_contact: 'Contactez-nous en indiquant l\u2019e-mail utilis\u00e9 lors du paiement et nous vous tiendrons inform\u00e9.',
      back_store: 'Retour \u00e0 la boutique', order_confirmed: 'Commande {name} confirm\u00e9e \u00b7 {amount}',
      country_IT: 'Italie', country_FR: 'France', country_ES: 'Espagne', country_DE: 'Allemagne',
      country_PT: 'Portugal', country_IE: 'Irlande',
    },
    es: {
      cart: 'Carrito', summary: 'Resumen del pedido', checkout: 'Pago', contacts: 'Contacto', email: 'Correo electr\u00f3nico',
      newsletter: 'Env\u00edame novedades y ofertas por correo', delivery: 'Entrega', country: 'Pa\u00eds / Regi\u00f3n',
      first_name: 'Nombre', last_name: 'Apellidos', address: 'Direcci\u00f3n',
      address2: 'Piso, portal, etc. (opcional)', city: 'Ciudad', phone: 'Tel\u00e9fono (opcional)',
      zip_IT: 'C\u00f3digo postal', zip_FR: 'C\u00f3digo postal', zip_ES: 'C\u00f3digo postal', zip_DE: 'C\u00f3digo postal', zip_PT: 'C\u00f3digo postal', zip_IE: 'Eircode',
      zip: 'C\u00f3digo postal', zip_AE: 'C\u00f3digo postal', zip_GB: 'Postcode',
      province_IT: 'Provincia', province_FR: 'Departamento', province_ES: 'Provincia', province_DE: 'Estado',
      province_PT: 'Distrito', province_IE: 'Condado', province: 'Regi\u00f3n', province_AE: 'Emirato', province_GB: 'Condado',
      shipping_method: 'M\u00e9todo de env\u00edo',
      ship_empty: 'Introduce tu direcci\u00f3n de env\u00edo para ver las opciones disponibles.',
      standard_shipping: 'Env\u00edo est\u00e1ndar', shipping: 'Env\u00edo', free: 'Gratis',
      ship_express_tracked: 'Env\u00edo express con seguimiento',
      ship_tracked: 'Env\u00edo con seguimiento',
      ship_eta_inner: 'Entrega en 24/48 h',
      ship_eta: '(Entrega en 24/48 h)',
      enter_address: 'Introduce la direcci\u00f3n de env\u00edo', payment: 'Pago',
      pay_secure: 'Todas las transacciones son seguras y est\u00e1n cifradas.', credit_card: 'Tarjeta de cr\u00e9dito',
      card_number: 'N\u00famero de tarjeta', card_expiry: 'MM / AA', card_cvc: 'CVC',
      card_name: 'Nombre en la tarjeta',
      pay_loading: 'Cargando el formulario de pago seguro\u2026',
      psp_choose: 'Elige c\u00f3mo pagar', psp_comercia: 'Comercia', psp_nexi: 'Nexi',
      psp_pick: 'Selecciona Comercia o Nexi para continuar.',
      psp_nexi_hint: 'Pulsa Pagar: te llevaremos a la p\u00e1gina segura de Nexi.',
      bank_connecting: 'Conexi\u00f3n segura con el banco\u2026', cancel_pay: 'Cancelar pago',
      disclaimer: 'Al continuar, aceptas que el importe se cargue en el m\u00e9todo de pago al procesar el pedido.',
      pay_now: 'Realizar pedido', processing: 'Procesando\u2026', subtotal: 'Subtotal', total: 'Total',
      pay_title: 'Pago seguro', wallet_title: 'Apple Pay o Google Pay',
      wallet_connecting: 'Conectando con Apple Pay / Google Pay\u2026',
      popup_blocked: 'El navegador ha bloqueado la ventana. Permite las ventanas emergentes e int\u00e9ntalo de nuevo.',
      pay_declined: 'El pago ha sido rechazado. Revisa los datos o usa otro m\u00e9todo.',
      pay_failed: 'El pago no se ha podido completar. Int\u00e9ntalo de nuevo.',
      network: 'No se ha podido contactar con el servicio de pago. Comprueba la conexi\u00f3n e int\u00e9ntalo de nuevo.',
      threeds_failed: 'La verificaci\u00f3n del banco no se ha completado. Revisa los datos e int\u00e9ntalo de nuevo.',
      cart_load: 'No se ha podido cargar el carrito. Actualiza la p\u00e1gina.',
      pay_load: 'No se ha podido cargar el formulario de pago. Int\u00e9ntalo de nuevo.',
      wallet_fail: 'No se ha podido iniciar Apple Pay / Google Pay.',
      err_card: 'La tarjeta ha sido rechazada. Revisa los datos o usa otra tarjeta.',
      err_email: 'Introduce un correo electr\u00f3nico v\u00e1lido.', err_address: 'Completa la direcci\u00f3n de env\u00edo.',
      err_shipping: 'No realizamos env\u00edos al pa\u00eds seleccionado.', err_empty: 'Tu carrito est\u00e1 vac\u00edo.',
      err_item: 'Un producto del carrito ya no est\u00e1 disponible.',
      err_locked: 'Este pago ya no est\u00e1 disponible. Actualiza la p\u00e1gina.',
      err_amount: 'El importe del pedido no es v\u00e1lido.',
      customer: 'Cliente', address_pending: 'Por completar',
      confirming: 'Confirmando el pedido\u2026',
      please_wait: 'Espera unos segundos mientras registramos tu pedido.',
      thanks: '\u00a1Gracias por tu pedido!', order_ok: 'Tu pedido se ha registrado correctamente.',
      email_soon: 'Recibir\u00e1s en breve un correo de confirmaci\u00f3n con los detalles del pedido y la informaci\u00f3n de env\u00edo.',
      continue: 'Seguir comprando', failed_title: 'Algo no ha funcionado',
      failed_body: 'No hemos podido confirmar tu pedido. Si el cargo se ha realizado, el pedido se registrar\u00e1 igualmente.',
      failed_contact: 'Cont\u00e1ctanos indicando el correo usado en el pago y te actualizaremos de inmediato.',
      back_store: 'Volver a la tienda', order_confirmed: 'Pedido {name} confirmado \u00b7 {amount}',
      country_IT: 'Italia', country_FR: 'Francia', country_ES: 'Espa\u00f1a', country_DE: 'Alemania',
      country_PT: 'Portugal', country_IE: 'Irlanda',
    },
    de: {
      cart: 'Warenkorb', summary: 'Bestell\u00fcbersicht', checkout: 'Kasse', contacts: 'Kontakt', email: 'E-Mail',
      newsletter: 'Neuigkeiten und Angebote per E-Mail erhalten', delivery: 'Lieferung', country: 'Land / Region',
      first_name: 'Vorname', last_name: 'Nachname', address: 'Adresse',
      address2: 'Wohnung, Stockwerk usw. (optional)', city: 'Stadt', phone: 'Telefon (optional)',
      zip_IT: 'PLZ', zip_FR: 'PLZ', zip_ES: 'PLZ', zip_DE: 'PLZ', zip_PT: 'PLZ', zip_IE: 'Eircode',
      zip: 'PLZ', zip_AE: 'Postleitzahl', zip_GB: 'Postcode',
      province_IT: 'Provinz', province_FR: 'D\u00e9partement', province_ES: 'Provinz', province_DE: 'Bundesland',
      province_PT: 'Distrikt', province_IE: 'County', province: 'Region', province_AE: 'Emirat', province_GB: 'County',
      shipping_method: 'Versandart',
      ship_empty: 'Gib deine Lieferadresse ein, um verf\u00fcgbare Versandarten anzuzeigen.',
      standard_shipping: 'Standardversand', shipping: 'Versand', free: 'Kostenlos',
      ship_express_tracked: 'Expressversand mit Sendungsverfolgung',
      ship_tracked: 'Versand mit Sendungsverfolgung',
      ship_eta_inner: 'Lieferung in 24/48 Std.',
      ship_eta: '(Lieferung in 24/48 Std.)',
      enter_address: 'Lieferadresse eingeben', payment: 'Zahlung',
      pay_secure: 'Alle Transaktionen sind sicher und verschl\u00fcsselt.', credit_card: 'Kreditkarte',
      card_number: 'Kartennummer', card_expiry: 'MM / JJ', card_cvc: 'CVC',
      card_name: 'Name auf der Karte',
      pay_loading: 'Sicheres Zahlungsformular wird geladen\u2026',
      psp_choose: 'Zahlungsmethode w\u00e4hlen', psp_comercia: 'Comercia', psp_nexi: 'Nexi',
      psp_pick: 'W\u00e4hlen Sie Comercia oder Nexi, um fortzufahren.',
      psp_nexi_hint: 'Klicken Sie auf Bestellen: Sie werden zur sicheren Nexi-Seite weitergeleitet.',
      bank_connecting: 'Sichere Verbindung zur Bank\u2026', cancel_pay: 'Zahlung abbrechen',
      disclaimer: 'Mit dem Fortfahren akzeptierst du, dass der Betrag bei der Bearbeitung der Bestellung abgebucht wird.',
      pay_now: 'Jetzt bestellen', processing: 'Wird verarbeitet\u2026', subtotal: 'Zwischensumme', total: 'Gesamt',
      pay_title: 'Sichere Zahlung', wallet_title: 'Apple Pay oder Google Pay',
      wallet_connecting: 'Verbindung zu Apple Pay / Google Pay\u2026',
      popup_blocked: 'Der Browser hat das Pop-up blockiert. Erlaube Pop-ups f\u00fcr diese Seite und versuche es erneut.',
      pay_declined: 'Die Zahlung wurde abgelehnt. Pr\u00fcfe die Daten oder nutze eine andere Methode.',
      pay_failed: 'Zahlung fehlgeschlagen. Bitte erneut versuchen.',
      network: 'Der Zahlungsdienst ist nicht erreichbar. Pr\u00fcfe die Verbindung und versuche es erneut.',
      threeds_failed: 'Die Bankpr\u00fcfung ist fehlgeschlagen. Pr\u00fcfe die Daten und versuche es erneut.',
      cart_load: 'Warenkorb konnte nicht geladen werden. Seite neu laden.',
      pay_load: 'Zahlungsformular konnte nicht geladen werden. Bitte erneut versuchen.',
      wallet_fail: 'Apple Pay / Google Pay konnte nicht gestartet werden.',
      err_card: 'Die Karte wurde abgelehnt. Pr\u00fcfe die Daten oder nutze eine andere Karte.',
      err_email: 'Gib eine g\u00fcltige E-Mail-Adresse ein.', err_address: 'Vervollst\u00e4ndige die Lieferadresse.',
      err_shipping: 'Wir liefern nicht in das ausgew\u00e4hlte Land.', err_empty: 'Dein Warenkorb ist leer.',
      err_item: 'Ein Artikel im Warenkorb ist nicht mehr verf\u00fcgbar.',
      err_locked: 'Diese Zahlung ist nicht mehr verf\u00fcgbar. Seite neu laden.',
      err_amount: 'Der Bestellbetrag ist ung\u00fcltig.',
      customer: 'Kunde', address_pending: 'Noch auszuf\u00fcllen',
      confirming: 'Bestellung wird best\u00e4tigt\u2026',
      please_wait: 'Einen Moment, wir speichern deine Bestellung.',
      thanks: 'Danke f\u00fcr deine Bestellung!', order_ok: 'Deine Bestellung wurde erfolgreich gespeichert.',
      email_soon: 'Du erh\u00e4ltst in K\u00fcrze eine Best\u00e4tigungs-E-Mail mit den Bestell- und Versanddetails.',
      continue: 'Weiter einkaufen', failed_title: 'Etwas ist schiefgelaufen',
      failed_body: 'Wir konnten deine Bestellung nicht best\u00e4tigen. Wurde der Betrag abgebucht, wird die Bestellung trotzdem erfasst.',
      failed_contact: 'Kontaktiere uns mit der beim Bezahlen verwendeten E-Mail, wir k\u00fcmmern uns sofort darum.',
      back_store: 'Zur\u00fcck zum Shop', order_confirmed: 'Bestellung {name} best\u00e4tigt \u00b7 {amount}',
      country_IT: 'Italien', country_FR: 'Frankreich', country_ES: 'Spanien', country_DE: 'Deutschland',
      country_PT: 'Portugal', country_IE: 'Irland',
    },
    pt: {
      cart: 'Carrinho', summary: 'Resumo da encomenda', checkout: 'Pagamento', contacts: 'Contactos', email: 'E-mail',
      newsletter: 'Enviar-me novidades e ofertas por e-mail', delivery: 'Entrega', country: 'Pa\u00eds / Regi\u00e3o',
      first_name: 'Nome', last_name: 'Apelido', address: 'Morada',
      address2: 'Andar, fra\u00e7\u00e3o, etc. (opcional)', city: 'Cidade', phone: 'Telefone (opcional)',
      zip_IT: 'C\u00f3digo postal', zip_FR: 'C\u00f3digo postal', zip_ES: 'C\u00f3digo postal', zip_DE: 'C\u00f3digo postal', zip_PT: 'C\u00f3digo postal', zip_IE: 'Eircode',
      zip: 'C\u00f3digo postal', zip_AE: 'C\u00f3digo postal', zip_GB: 'Postcode',
      province_IT: 'Prov\u00edncia', province_FR: 'Departamento', province_ES: 'Prov\u00edncia', province_DE: 'Estado',
      province_PT: 'Distrito', province_IE: 'Condado', province: 'Regi\u00e3o', province_AE: 'Emirado', province_GB: 'Condado',
      shipping_method: 'M\u00e9todo de envio',
      ship_empty: 'Introduz a morada de entrega para ver os m\u00e9todos de envio dispon\u00edveis.',
      standard_shipping: 'Envio standard', shipping: 'Envio', free: 'Gr\u00e1tis',
      ship_express_tracked: 'Envio expresso rastreado',
      ship_tracked: 'Envio rastreado',
      ship_eta_inner: 'Entrega em 24/48 h',
      ship_eta: '(Entrega em 24/48 h)',
      enter_address: 'Introduzir morada de entrega', payment: 'Pagamento',
      pay_secure: 'Todas as transa\u00e7\u00f5es s\u00e3o seguras e encriptadas.', credit_card: 'Cart\u00e3o de cr\u00e9dito',
      card_number: 'N\u00famero do cart\u00e3o', card_expiry: 'MM / AA', card_cvc: 'CVC',
      card_name: 'Nome no cart\u00e3o',
      pay_loading: 'A carregar o formul\u00e1rio de pagamento seguro\u2026',
      psp_choose: 'Escolha como pagar', psp_comercia: 'Comercia', psp_nexi: 'Nexi',
      psp_pick: 'Selecione Comercia ou Nexi para continuar.',
      psp_nexi_hint: 'Clique em Pagar: ser\u00e1 enviado para a p\u00e1gina segura Nexi.',
      bank_connecting: 'Liga\u00e7\u00e3o segura ao banco\u2026', cancel_pay: 'Cancelar pagamento',
      disclaimer: 'Ao continuar, aceitas que o valor seja debitado no m\u00e9todo de pagamento ao processar a encomenda.',
      pay_now: 'Fazer encomenda', processing: 'A processar\u2026', subtotal: 'Subtotal', total: 'Total',
      pay_title: 'Pagamento seguro', wallet_title: 'Apple Pay ou Google Pay',
      wallet_connecting: 'A ligar ao Apple Pay / Google Pay\u2026',
      popup_blocked: 'O browser bloqueou a janela. Permite pop-ups neste site e tenta novamente.',
      pay_declined: 'O pagamento foi recusado. Verifica os dados ou usa outro m\u00e9todo.',
      pay_failed: 'O pagamento falhou. Tenta novamente.',
      network: 'N\u00e3o foi poss\u00edvel contactar o servi\u00e7o de pagamento. Verifica a liga\u00e7\u00e3o e tenta novamente.',
      threeds_failed: 'A verifica\u00e7\u00e3o do banco falhou. Verifica os dados e tenta novamente.',
      cart_load: 'N\u00e3o foi poss\u00edvel carregar o carrinho. Atualiza a p\u00e1gina.',
      pay_load: 'N\u00e3o foi poss\u00edvel carregar o formul\u00e1rio de pagamento. Tenta novamente.',
      wallet_fail: 'N\u00e3o foi poss\u00edvel iniciar o Apple Pay / Google Pay.',
      err_card: 'O cart\u00e3o foi recusado. Verifica os dados ou usa outro cart\u00e3o.',
      err_email: 'Introduz um e-mail v\u00e1lido.', err_address: 'Completa a morada de entrega.',
      err_shipping: 'N\u00e3o enviamos para o pa\u00eds selecionado.', err_empty: 'O teu carrinho est\u00e1 vazio.',
      err_item: 'Um produto do carrinho j\u00e1 n\u00e3o est\u00e1 dispon\u00edvel.',
      err_locked: 'Este pagamento j\u00e1 n\u00e3o est\u00e1 dispon\u00edvel. Atualiza a p\u00e1gina.',
      err_amount: 'O valor da encomenda n\u00e3o \u00e9 v\u00e1lido.',
      customer: 'Cliente', address_pending: 'A completar',
      confirming: 'A confirmar a encomenda\u2026',
      please_wait: 'Aguarda alguns segundos enquanto registamos a tua encomenda.',
      thanks: 'Obrigado pela tua encomenda!', order_ok: 'A tua encomenda foi registada com sucesso.',
      email_soon: 'Vais receber em breve um e-mail de confirma\u00e7\u00e3o com os detalhes da encomenda e do envio.',
      continue: 'Continuar a comprar', failed_title: 'Algo correu mal',
      failed_body: 'N\u00e3o foi poss\u00edvel confirmar a encomenda. Se o pagamento foi efetuado, a encomenda ser\u00e1 mesmo assim registada.',
      failed_contact: 'Contacta-nos com o e-mail usado no pagamento e atualizamos de imediato.',
      back_store: 'Voltar \u00e0 loja', order_confirmed: 'Encomenda {name} confirmada \u00b7 {amount}',
      country_IT: 'It\u00e1lia', country_FR: 'Fran\u00e7a', country_ES: 'Espanha', country_DE: 'Alemanha',
      country_PT: 'Portugal', country_IE: 'Irlanda',
    },
    en: {
      cart: 'Cart', summary: 'Order summary', checkout: 'Checkout', contacts: 'Contact', email: 'Email',
      newsletter: 'Email me with news and offers', delivery: 'Delivery', country: 'Country / Region',
      first_name: 'First name', last_name: 'Last name', address: 'Address',
      address2: 'Apartment, suite, etc. (optional)', city: 'City', phone: 'Phone (optional)',
      zip_IT: 'Postal code', zip_FR: 'Postal code', zip_ES: 'Postal code', zip_DE: 'Postal code', zip_PT: 'Postal code', zip_IE: 'Eircode',
      zip: 'Postal code', zip_AE: 'Postal code', zip_GB: 'Postcode',
      province_IT: 'Province', province_FR: 'Department', province_ES: 'Province', province_DE: 'State',
      province_PT: 'District', province_IE: 'County', province: 'Region', province_AE: 'Emirate', province_GB: 'County',
      shipping_method: 'Shipping method',
      ship_empty: 'Enter your shipping address to see available shipping methods.',
      standard_shipping: 'Standard shipping', shipping: 'Shipping', free: 'Free',
      ship_express_tracked: 'Express tracked shipping',
      ship_tracked: 'Tracked shipping',
      ship_eta_inner: 'Delivery in 24/48 hours',
      ship_eta: '(Delivery in 24/48 hours)',
      enter_address: 'Enter shipping address', payment: 'Payment',
      pay_secure: 'All transactions are secure and encrypted.', credit_card: 'Credit card',
      card_number: 'Card number', card_expiry: 'MM / YY', card_cvc: 'CVC',
      card_name: 'Name on card',
      pay_loading: 'Loading the secure payment form\u2026',
      psp_choose: 'Choose how to pay', psp_comercia: 'Comercia', psp_nexi: 'Nexi',
      psp_pick: 'Select Comercia or Nexi to continue.',
      psp_nexi_hint: 'Click Pay now: you will be taken to the secure Nexi page.',
      bank_connecting: 'Secure connection to the bank\u2026', cancel_pay: 'Cancel payment',
      disclaimer: 'By continuing, you agree that the amount will be charged to your payment method when the order is processed.',
      pay_now: 'Pay now', processing: 'Processing\u2026', subtotal: 'Subtotal', total: 'Total',
      pay_title: 'Secure payment', wallet_title: 'Apple Pay or Google Pay',
      wallet_connecting: 'Connecting to Apple Pay / Google Pay\u2026',
      popup_blocked: 'The browser blocked the popup. Allow popups for this site and try again.',
      pay_declined: 'The payment was declined. Check the details or use another method.',
      pay_failed: 'Payment failed. Please try again.',
      network: 'Could not reach the payment service. Check your connection and try again.',
      threeds_failed: 'Bank verification did not complete. Check the details and try again.',
      cart_load: 'Could not load the cart. Refresh the page.',
      pay_load: 'Could not load the payment form. Please try again.',
      wallet_fail: 'Could not start Apple Pay / Google Pay.',
      err_card: 'The card was declined. Check the details or use another card.',
      err_email: 'Enter a valid email address.', err_address: 'Complete the shipping address.',
      err_shipping: 'We do not ship to the selected country.', err_empty: 'Your cart is empty.',
      err_item: 'An item in the cart is no longer available.',
      err_locked: 'This payment is no longer available. Refresh the page.',
      err_amount: 'The order amount is not valid.',
      customer: 'Customer', address_pending: 'To be completed',
      confirming: 'Confirming your order\u2026',
      please_wait: 'Please wait a few seconds while we record your order.',
      thanks: 'Thank you for your order!', order_ok: 'Your order has been recorded successfully.',
      email_soon: 'You will shortly receive a confirmation email with the order details and shipping information.',
      continue: 'Continue shopping', failed_title: 'Something went wrong',
      failed_body: 'We could not confirm your order. If the charge went through, the order will still be recorded.',
      failed_contact: 'Contact us with the email used at payment and we will update you right away.',
      back_store: 'Back to the store', order_confirmed: 'Order {name} confirmed \u00b7 {amount}',
      country_IT: 'Italy', country_FR: 'France', country_ES: 'Spain', country_DE: 'Germany',
      country_PT: 'Portugal', country_IE: 'Ireland',
    },
  };

  function parseTag(tag) {
    var value = String(tag || '').trim();
    if (!value) return null;
    try {
      var loc = new Intl.Locale(value);
      return { lang: String(loc.language || '').toLowerCase(), region: String(loc.region || '').toUpperCase() };
    } catch (e) {
      var parts = value.replace('_', '-').split('-');
      return { lang: String(parts[0] || '').toLowerCase(), region: String(parts[1] || '').toUpperCase() };
    }
  }

  function shopFallbackLang() {
    if (SUPPORTED[LOCK_LANG]) return LOCK_LANG;
    var shop = String((root.Shopify && root.Shopify.shop) || root.MERIDIAN_SHOP || location.hostname || '').toLowerCase();
    if (shop.indexOf('iqesxk-pw.myshopify.com') !== -1 || shop.indexOf('velnex') !== -1) return 'fr';
    if (shop.indexOf('j6dytb-4z.myshopify.com') !== -1 || shop.indexOf('maison-nova') !== -1) return 'fr';
    return 'it';
  }

  function detectLocale() {
    var params = new URLSearchParams(location.search);
    var forcedLang = String(params.get('locale') || params.get('lang') || '').toLowerCase().split('-')[0];
    var forcedCountry = String(params.get('country') || '').toUpperCase();
    if (SUPPORTED[LOCK_LANG] && !SUPPORTED[forcedLang]) {
      return {
        lang: LOCK_LANG,
        country: LOCK_COUNTRIES[0] || LANG_COUNTRY[LOCK_LANG] || 'FR',
      };
    }
    var raw = [];
    if (navigator.languages && navigator.languages.length) {
      for (var i = 0; i < navigator.languages.length; i++) raw.push(navigator.languages[i]);
    }
    raw.push(navigator.language || '');
    raw.push(navigator.userLanguage || '');
    var lang = SUPPORTED[forcedLang] ? forcedLang : '';
    var region = /^[A-Z]{2}$/.test(forcedCountry) ? forcedCountry : '';
    for (var j = 0; j < raw.length; j++) {
      var parsed = parseTag(raw[j]);
      if (!parsed) continue;
      if (!lang && SUPPORTED[parsed.lang]) lang = parsed.lang;
      if (!region && /^[A-Z]{2}$/.test(parsed.region)) region = parsed.region;
      if (lang && region) break;
    }
    var shopifyCountry = String((root.Shopify && root.Shopify.country) || '').toUpperCase();
    var shopifyLang = String((root.Shopify && root.Shopify.locale) || document.documentElement.getAttribute('lang') || '').toLowerCase().split('-')[0];
    if (!lang && SUPPORTED[shopifyLang]) lang = shopifyLang;
    if (!lang) lang = shopFallbackLang();
    if (LOCK_COUNTRIES.length) region = LOCK_COUNTRIES[0];
    if (!region && LANG_COUNTRY[lang]) region = LANG_COUNTRY[lang];
    if (!region && /^[A-Z]{2}$/.test(shopifyCountry)) region = shopifyCountry;
    return { lang: lang, country: region };
  }

  var locale = detectLocale();
  var shipTo = [];
  var shipProvinces = {};

  function pack() {
    return I18N[locale.lang] || I18N.it;
  }

  function t(key) {
    var dict = pack();
    return dict[key] || I18N.it[key] || key;
  }

  function format(key, vars) {
    var text = t(key);
    Object.keys(vars || {}).forEach(function (name) {
      text = text.replace(new RegExp('\\{' + name + '\\}', 'g'), String(vars[name]));
    });
    return text;
  }

  function euros(cents) {
    return (Number(cents) / 100).toLocaleString(NUMBER_LOCALE[locale.lang] || 'it-IT', { style: 'currency', currency: 'EUR' });
  }

  function applyNode(node) {
    if (!node || !node.querySelectorAll) return;
    node.querySelectorAll('[data-i18n]').forEach(function (el) {
      var key = el.getAttribute('data-i18n');
      if (key) el.textContent = t(key);
    });
    node.querySelectorAll('[data-i18n-aria]').forEach(function (el) {
      var key = el.getAttribute('data-i18n-aria');
      if (key) el.setAttribute('aria-label', t(key));
    });
    node.querySelectorAll('[data-i18n-title]').forEach(function (el) {
      var key = el.getAttribute('data-i18n-title');
      if (key) el.setAttribute('title', t(key));
    });
  }

  function apply(root) {
    var scope = root || document;
    document.documentElement.lang = locale.lang;
    applyNode(scope);
    if (scope.querySelectorAll) {
      scope.querySelectorAll('template').forEach(function (tpl) {
        applyNode(tpl.content);
      });
    }
  }

  function fieldLabel(prefix, country) {
    var specific = t(prefix + '_' + country);
    if (specific && specific !== prefix + '_' + country) return specific;
    return t(prefix);
  }

  function countryName(code) {
    var key = 'country_' + code;
    var labeled = t(key);
    if (labeled && labeled !== key) return labeled;
    try {
      var names = new Intl.DisplayNames([locale.lang], { type: 'region' });
      return names.of(code) || code;
    } catch (e) {
      return code;
    }
  }

  function pickShippableCountry(shopCountry) {
    var params = new URLSearchParams(location.search);
    var candidates = [
      String(params.get('country') || '').toUpperCase(),
      locale.country,
      String((root.Shopify && root.Shopify.country) || '').toUpperCase(),
      String(shopCountry || '').toUpperCase(),
    ];
    if (LOCK_COUNTRIES.length) {
      for (var c = 0; c < candidates.length; c++) {
        if (LOCK_COUNTRIES.indexOf(candidates[c]) > -1) return candidates[c];
      }
      return LOCK_COUNTRIES[0];
    }
    for (var i = 0; i < candidates.length; i++) {
      if (shipTo.indexOf(candidates[i]) > -1) return candidates[i];
    }
    return shipTo[0] || '';
  }

  function setShipTo(countries, shopCountry) {
    shipTo = [];
    shipProvinces = {};
    (countries || []).forEach(function (row) {
      var code = String(row && row.code || row || '').toUpperCase();
      if (!code) return;
      if (LOCK_COUNTRIES.length && LOCK_COUNTRIES.indexOf(code) < 0) return;
      shipTo.push(code);
      var list = row && row.provinces;
      if (list && list.length) shipProvinces[code] = list.slice();
    });
    if (LOCK_COUNTRIES.length && !shipTo.length) {
      shipTo = LOCK_COUNTRIES.slice();
    }
    locale.country = pickShippableCountry(shopCountry);
  }

  function fillCountries(select) {
    if (!select) return;
    var list = shipTo.length ? shipTo : (LOCK_COUNTRIES.length ? LOCK_COUNTRIES.slice() : []);
    var current = select.value || locale.country;
    select.innerHTML = list.map(function (code) {
      return '<option value="' + code + '">' + countryName(code) + '</option>';
    }).join('');
    select.value = list.indexOf(current) > -1 ? current : (locale.country || list[0] || '');
  }

  function applyFieldLabels(form) {
    if (!form) return;
    var country = form.elements.country_code && form.elements.country_code.value || locale.country;
    var zip = document.querySelector('label[for="sc-zip"]');
    var province = document.querySelector('label[for="sc-province"]');
    var address2 = document.querySelector('label[for="sc-address2"]');
    if (zip) zip.textContent = fieldLabel('zip', country);
    if (province) province.textContent = fieldLabel('province', country);
    if (address2) address2.textContent = t('address2');
    var zipInput = form.elements.zip;
    if (zipInput) zipInput.inputMode = (country === 'IE' || country === 'GB' || country === 'AE') ? 'text' : 'numeric';
  }

  function setProvinces(form) {
    if (!form || !form.elements.province || !form.elements.country_code) return;
    var select = form.elements.province;
    var country = form.elements.country_code.value;
    var list = shipProvinces[country] || PROVINCES[country];
    var field = document.getElementById('sc-province-field');
    if (!list || !list.length) {
      if (field) field.hidden = true;
      select.required = false;
      select.innerHTML = '<option value=""></option>';
      return;
    }
    if (field) field.hidden = false;
    select.required = true;
    var current = select.value;
    select.innerHTML = list.map(function (name) {
      return '<option value="' + name + '">' + name + '</option>';
    }).join('');
    select.value = list.indexOf(current) > -1 ? current : list[0];
  }

  function cityFallback(country) {
    return CITY_FALLBACK[country] || { city: '', zip: '' };
  }

  function shippingLabel(rawTitle) {
    var title = String(rawTitle || '').replace(/\s+/g, ' ').trim();
    var inner = '';
    var wrapped = title.match(/^(.*?)\s*\((.+)\)\s*$/);
    if (wrapped) {
      title = wrapped[1].trim();
      inner = wrapped[2].trim();
    }
    var lower = title.toLowerCase();
    if (/express/.test(lower) && /(tracciat|tracked|suivi|seguit|rastre|sendungsverfolg)/.test(lower)) {
      title = t('ship_express_tracked');
    } else if (/(tracciat|tracked|suivi|seguit|rastre|sendungsverfolg)/.test(lower)) {
      title = t('ship_tracked');
    } else if (/(standard|ordinaria)/.test(lower)) {
      title = t('standard_shipping');
    } else if (!title || /^(shipping|spedizione)$/i.test(title)) {
      title = t('ship_express_tracked');
    }
    if (!inner || /24\s*\/?\s*48/.test(inner)) inner = t('ship_eta_inner');
    return { title: title, subtitle: '(' + inner.replace(/^\(+|\)+$/g, '') + ')' };
  }

  function englishPolicyLabel(href, title) {
    var path = String(href || '').toLowerCase();
    if (path.indexOf('privacy-policy') !== -1) return 'Privacy policy';
    if (path.indexOf('refund-policy') !== -1) return 'Refund policy';
    if (path.indexOf('terms-of-service') !== -1) return 'Terms of service';
    if (path.indexOf('shipping-policy') !== -1) return 'Shipping policy';
    if (path.indexOf('contact-information') !== -1) return 'Contact information';
    if (path.indexOf('legal-notice') !== -1) return 'Legal notice';
    if (path.indexOf('subscription-policy') !== -1) return 'Subscription policy';
    var hay = (path + ' ' + String(title || '')).toLowerCase();
    if (/privacy/.test(hay)) return 'Privacy policy';
    if (/refund|rimborso|remboursement|reembolso|widerruf/.test(hay)) return 'Refund policy';
    if (/shipping|spedizion|expedition|versand/.test(hay)) return 'Shipping policy';
    if (/terms|condizion|condiciones|bedingungen|servizio|servicio/.test(hay)) return 'Terms of service';
    if (/contact|contatt|coordonn/.test(hay)) return 'Contact information';
    if (/legal|legali|notice|mentions|impressum/.test(hay)) return 'Legal notice';
    return 'Policy';
  }

  function applyEnglishPolicies(rootEl) {
    var scope = rootEl || document;
    if (!scope.querySelectorAll) return;
    scope.querySelectorAll('.sc-foot a').forEach(function (link) {
      link.textContent = englishPolicyLabel(link.getAttribute('href'), link.textContent);
    });
  }

  root.MeridianI18n = {
    locale: locale,
    countries: COUNTRIES,
    provinces: PROVINCES,
    t: t,
    format: format,
    euros: euros,
    apply: apply,
    setShipTo: setShipTo,
    fillCountries: fillCountries,
    applyFieldLabels: applyFieldLabels,
    setProvinces: setProvinces,
    cityFallback: cityFallback,
    shippingLabel: shippingLabel,
    applyEnglishPolicies: applyEnglishPolicies,
  };
})(window);
